export function BrandMark({ className }: { readonly className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 62 86"
      fill="none"
      aria-hidden="true"
    >
      <path d="M0 8h40l22 22v56H0V8z" fill="var(--accent)" />
      <path d="M40 8v22h22" fill="var(--night-ink)" />
      <path
        d="M12 48h28M12 62h20"
        stroke="var(--night-ink)"
        strokeWidth="3.2"
        strokeLinecap="round"
      />
    </svg>
  );
}
